export const getNormalizedFilter = (rawFilter: any) => {
    return typeof rawFilter === 'object' ? (rawFilter ?? {}) : {};
};
